import React from "react";
import PropTypes from "prop-types";
import LocalNavSoftLink from "../LocalNavSoftLink";

export default function AdminGlobalLinks({ hasSuperAdmin, hasExperianAdmin, hasCompanySelected }) {
    return (
        <>
            <LocalNavSoftLink removeLi id="user-admin" destination="/admin/users" text="Users" />
            <LocalNavSoftLink removeLi id="companies" destination="/admin/companies" text="Companies" />
            {hasCompanySelected && (hasSuperAdmin || hasExperianAdmin) && (
                <LocalNavSoftLink
                    removeLi
                    id="secured-shared-folders"
                    destination="/admin/secured-shared-folders"
                    text="Secured Shared Folders"
                    feature="fsd-secured-shared-folder"
                />
            )}
            {hasSuperAdmin && (
                <LocalNavSoftLink
                    removeLi
                    id="destination-groups"
                    destination="/admin/destination-groups"
                    text="Destination Groups"
                />
            )}
            {hasSuperAdmin && (
                <LocalNavSoftLink removeLi id="migration" destination="/admin/migration" text="Migration" />
            )}
            {hasSuperAdmin && (
                <LocalNavSoftLink removeLi id="app-settings" destination="/admin/app-settings" text="App Settings" />
            )}
        </>
    );
}

// Mark safe for LocalNavMenu structural expansion (must remain hook-free)
AdminGlobalLinks.__localNavSection = true;

AdminGlobalLinks.propTypes = {
    hasSuperAdmin: PropTypes.bool.isRequired,
    hasExperianAdmin: PropTypes.bool,
    hasCompanySelected: PropTypes.bool,
};
